export * from './replace-all.pipe';
